<script>

    export let label = ''
    export let value = null
    
</script>

<small style="font-weight: bold;">{ label }</small>
<div>{ value }</div>